
import { Component, Vue } from "vue-property-decorator";
import { Loading, Toast } from "vant";
import { ReportService, FileService, StoreProductService } from "src/services";
import dayjs, { unix } from "dayjs";
import pageBack from "src/components/page-back";
import router from "src/router";


@Component({
    components:
    {
        pageBack,
    }
})
 export default class ReportAdd extends Vue
 {

    /**
     * 权益列表
     * @private
     * @returns void
     */
    public rightsList = []

    /**
     * ids
     * @private
     * @returns Array<number>
     */
     private get ids()
    {
        let ids = [];
        if (localStorage.getItem("rightsList"))
        {
            ids = JSON.parse(localStorage.getItem("rightsList"));
        }
        return this.$route.params && (this.$route.params.ids) || ids;
    }

    /**
     * 组件创建钩子
     */
     protected created()
    {
        this.getRightsList()
    }

    /*
    * 获取权益列表
    * @private
    * @returns void
    */
    private async getRightsList()
    {
        try {
            let { content: res } = await StoreProductService.instance.getRightsListByPost({ids: this.ids});
            if(res.data)
            {
                this.rightsList = res.data
            }
        } catch (err) {
            Toast(err);
        }
    }

    /**
     * 跳转权益详情
     * @private
     * @returns void
     */
     private viewRightsDetail(id) {
        this.$router.push({name:"rights-shop-detail",query:{id}})
    }


 }





